module.exports = __webpack_public_path__ + "static/img/mt.cfb2463.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/mt.png
// module id = SchU
// module chunks = 18